import React from "react";
import { Link } from "react-router-dom";
import { Content } from "../Content";
import { ExternalLink } from "../ExternalLink";
import { FacebookMenuItem, MenuItem } from "../MenuItem";
import { ResponsiveLayout } from "../ResponsiveLayout";
import { translation } from "../translations";
import {
  careersUrl,
  facebookPageUrl,
  LogoWide,
  NavigationPath,
} from "./NavigationCommon";

export const DesktopNavigation: React.FC = () => {
  return (
    <Content>
      <ResponsiveLayout justifyContent="center">
        <Link to={NavigationPath.home}>
          <MenuItem width={140}>
            <LogoWide />
          </MenuItem>
        </Link>

        <Link to={NavigationPath.biologicalAge}>
          <MenuItem navigationPath={NavigationPath.biologicalAge} width={200}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div>{translation.navBiologicalAgeTitle}</div>
              <div style={{ fontSize: 12 }}>
                {translation.navBiologicalAgeSubtitle}
              </div>
            </div>
          </MenuItem>
        </Link>

        <Link to={NavigationPath.team}>
          <MenuItem navigationPath={NavigationPath.team}>
            {translation.navTeam}
          </MenuItem>
        </Link>

        <ExternalLink href={careersUrl}>
          <MenuItem>{translation.navCareers}</MenuItem>
        </ExternalLink>

        <Link to={NavigationPath.insurers}>
          <MenuItem navigationPath={NavigationPath.insurers} width={230}>
            {translation.navInsurers}
          </MenuItem>
        </Link>

        <ExternalLink href={facebookPageUrl}>
          <FacebookMenuItem />
        </ExternalLink>
      </ResponsiveLayout>
    </Content>
  );
};
